import React from "react";
import {
    CaretUpFilled,
    CaretDownFilled,
} from '@ant-design/icons';
import { generateClassName } from "jzfz-web-utils";
import './style/sortButton.less';


interface SortButtonProps {
    className?: string;
    children?: React.ReactNode;
    value?: any;
    onChange?: (value: DirectionName | null) => void;
}


export enum DirectionName {
    'asc' = 'asc',  // 升序
    'desc' = 'desc', // 降序
}


/**
 * 排序按钮
 * @constructor
 */
const SortButton = (props: SortButtonProps) => {
    const { className = '', value, children = null, onChange = (value: DirectionName | null) => {} } = props;


    /**
     * 点击排序
     */
    const sortClickHandle = () => {
        if (!value) {
            onChange(DirectionName.asc);
            return;
        }
        if (value === DirectionName.asc) {
            onChange(DirectionName.desc);
            return;
        }
        if (value === DirectionName.desc) {
            onChange(null);
            return;
        }
    }


    const getTitle = (): string => {
        if (value === DirectionName.asc) {
            return '升序';
        }
        if (value === DirectionName.desc) {
            return '降序';
        }
        return '';
    }


    return (
        <>
            <div className={generateClassName(['custom-sort-button-wrap', className])}>
                <div title={getTitle()} onClick={sortClickHandle}>
                    <CaretUpFilled
                        className={generateClassName(['sort-icon', value === DirectionName.asc ? 'active' : ''])}
                    />
                    <CaretDownFilled
                        className={generateClassName(['sort-icon', value === DirectionName.desc ? 'active' : ''])}
                    />
                </div>
            </div>
            {children}
        </>
    )
}


export default SortButton;
